import React from 'react';
import useAuth from '../../hooks/useAuth';
import './AverageOtherGoals.css';

interface AverageOtherGoalsProps {
  goals?: Array<{
    id: string;
    title?: string;
    goal?: string;
    active?: boolean;
  }>;
  onClick?: (id: string) => void;
  profileId?: number;
}

const AverageOtherGoals = ({
  goals = [],
  onClick,
  profileId,
}: AverageOtherGoalsProps) => {
  const { user } = useAuth();

  const getGoalText = (item: any) => {
    if (profileId === user?.profile_id) {
      return item.goal || '';
    }
    return item.goal === 'Set Goal' ? 'No Goals yet' : item.goal;
  };

  return (
    <div className="goals-container">
      {goals.map((item) => {
        const isActive = item.active || false;
        const itemClass = `goal-item ${isActive ? 'active' : 'inactive'}`;
        const titleClass = `goal-title ${isActive ? 'active' : 'inactive'}`;
        const goalClass = `goal-text ${isActive ? 'active' : 'inactive'}`;

        return (
          <div
            key={item.id}
            className={itemClass}
            onClick={() => onClick?.(item?.title || '')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.(item.title || '');
              }
            }}
            aria-pressed={isActive}
          >
            <div className={titleClass}>
              {item.title || 'Breathing exercises'}
            </div>
            <div className={goalClass}>
              {getGoalText(item)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AverageOtherGoals;
